import { render, staticRenderFns } from "./adjustmentOverview.vue?vue&type=template&id=3895a4a1"
import script from "./adjustmentOverview.vue?vue&type=script&lang=js"
export * from "./adjustmentOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports